import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function RealProblemSection() {
  return <section className="w-full bg-[#f1f5f9] py-20 px-4" data-id="element-317">
      <div className="max-w-[680px] mx-auto" data-id="element-318">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-319">
          <h2 className="font-serif text-3xl md:text-4xl text-[#0f172a] mb-8 leading-tight" data-id="element-320">
            El Problema Real No Es Que <br data-id="element-321" />
            <span className="italic text-[#5b8a7a]" data-id="element-322">"Tu Bebé No Duerme".</span>
          </h2>

          <p className="text-lg md:text-xl leading-[1.8] text-[#2d2926] mb-8 font-light" data-id="element-323">
            El problema real es que a las 2AM tú estás sola con una pregunta
            venenosa: <span className="font-bold" data-id="element-324">"¿Qué hago ahora?"</span>
          </p>

          <p className="text-lg md:text-xl leading-[1.8] text-[#2d2926] mb-8 font-light" data-id="element-325">
            Y esa pregunta —cada 45–90 minutos— te va drenando. Porque cuando no
            hay secuencia, pasa esto:
          </p>

          <div className="bg-white p-8 rounded-xl shadow-sm border border-slate-100 mb-10" data-id="element-326">
            <ul className="space-y-4" data-id="element-327">
              {['Cambias luz, posición, pecho, pañal, música, caminata…', 'Lo estimulas sin querer', 'Tú te activas más', 'Y el bebé aprende que cada despertar se vuelve una "hora despiertos"'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#475569]" data-id="element-328">
                  <AlertCircle className="w-5 h-5 text-[#e8856c] mt-1 shrink-0" data-id="element-329" />
                  <span className="text-lg" data-id="element-330">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="text-center" data-id="element-331">
            <p className="text-lg text-[#64748b] mb-4" data-id="element-332">No es culpa tuya.</p>
            <h3 className="font-serif text-2xl md:text-3xl font-bold text-[#0f172a]" data-id="element-333">
              Es que nadie te dio un guion.
            </h3>
          </div>
        </motion.div>
      </div>
    </section>;
}